import React, { useState } from "react";
import { css } from "emotion";
import { Form } from "react-bootstrap";
import Order from "app/orderTool/pages/missingInformations/Order";
import { useOrders } from "app/orderTool/context/OrdersProvider";
import FakeDelivery from "app/deliveryTool/components/delivery/FakeDelivery";

const Orders = (props) => {

  const ordersResults = useOrders();
  const {
    orders
  } = ordersResults;

  const [hideFilledFields, setHideFilledFields] = useState(true);

  const styles = {
    title: {
      color: "grey",
      fontSize: "1.0rem",
      marginTop: "1.0rem",
      textAlign: "right",
    },
    load: {
      background: "white",
      margin: "0.5rem 0",
      border: "1px solid #ddd",
      padding: "1.0rem",
      fontWeight: "normal",
    },
    filterContainer: {
      background: "white",
      margin: "0.5rem 0",
      border: "1px solid #ddd",
      padding: "1.0rem",
      marginBottom: "1.0rem",
    },
    checkbox: {
      marginLeft: "0.5rem",
    },
  };

  return (
    <div className={css(styles.scroll)}>
      <div className={css(styles.filterContainer)}>
        <Form.Check
          type="checkbox"
          id="show-filled-fields"
          label="Afficher les champs manquants remplis"
          checked={!hideFilledFields}
          onChange={(e) => setHideFilledFields(!e.target.checked)}
          className={css(styles.checkbox)}
        />
      </div>
      {ordersResults.loading ? (
        <FakeDelivery />
      ) : (
        <div>
          {orders && orders.length > 0 ? (
            <div>
              {orders &&
                orders.map((order, index) => (
                  <Order 
                    order={order} 
                    key={index} 
                    handleMissingFieldsCustomerNotification={ordersResults.sendMissingFieldsCustomerNotification}
                    hideFilledFields={hideFilledFields}
                  />
                ))}
            </div>
          ) : (
            <p className={css(styles.load)}>
              <b>Il n'y a pas de résultat pour cette recherche.</b>
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default Orders;
